import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import type { AutocompleteChangeReason } from "@mui/material/Autocomplete";
import { FormInputProps } from "../form-input";
import { FormItemOption } from "../form-builder.model";
import { useMemo, useState } from "react";
import { FormItemLabel } from "./form-item-label";

export type ComboBoxInputProps = {
  options: FormItemOption[];
} & Omit<FormInputProps, "formLayout">;

// TODO -- if the options change, they are not being updated
export const ComboBoxInput: React.FC<ComboBoxInputProps> = ({
  formItem,
  setValue,
  options,
}) => {
  const mappedFormItemOptions = useMemo(() => {
    return options.map((opt) => ({
      label: opt.text,
      value: `${opt.value ?? ""}`,
    }));
  }, [options]);

  const [localOptions] = useState<string[]>(
    mappedFormItemOptions.map((o) => o.label),
  );

  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const handleChange = (
    _event: unknown,
    value: string[] | string,
    _reason: AutocompleteChangeReason,
  ) => {
    const vals = Array.isArray(value) ? value : [value];
    setSelectedValues(vals);
    setValue(vals);
  };

  return (
    <div className="_combobox-input.tsx combobox-input">
      <Autocomplete
        multiple
        freeSolo
        options={localOptions}
        value={selectedValues}
        onChange={(e, value) => handleChange(e, value, "selectOption")}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <FormItemLabel
                label={formItem.label ?? formItem.name}
                helpText={formItem.helpText}
              />
            }
          />
        )}
        disabled={formItem.disabled}
      />
    </div>
  );
};
